import {EntityFactory, Reducer} from '@modifi/redux'
import ms from 'ms'
import {socratesClientFactory, getFormattedLocale} from '@modifi/website-client'

const client = socratesClientFactory()

const {actions, reducer, selectors} = EntityFactory({
  fetchRequest: async (
    state,
    {pageType, pageSlug, locale}: {pageType: string; pageSlug: string; locale: string}
  ) => {
    const updatedLocale = getFormattedLocale(locale)
    return client.Page.fetch({pageType, pageSlug, locale: updatedLocale}).then(
      (res: {data: () => any}) => res.data()
    )
  },
  actionNamePrefix: 'pages/website-cms-page',
  rootSelector: state => state?.pages?.websiteCmsPage || {},
  cacheKeyFunc: ({
    pageType,
    pageSlug,
    locale,
  }: {
    pageType: string
    pageSlug: string
    locale: string
  }) => `${pageType}|${pageSlug}|${locale}`,
  cacheOptions: {
    ttl: ms('1h'),
    max: 15,
  },
})

export default reducer as Reducer

export const aFetchWebsiteCmsPage = (pageType: string, pageSlug: string, locale: string): any =>
  actions?.fetch({pageType, pageSlug, locale})

export const selectWebsiteCmsPageIsLoading = (state: Record<string, any>): boolean => {
  if (selectors.selectEntity(state)) {
    return false
  }
  return selectors.selectIsLoading(state)
}

export const {selectEntity: selectWebsiteCmsPage, selectIsError: selectWebsiteCmsPageHasError} =
  selectors
